export default __webpack_public_path__ + "static/media/generosity-outline.895f01fd.svg";